import type { RouteLocationNormalized, RouteRecordName } from 'vue-router';
import { isNativeCognitoEnabled } from '@/shared/auth/cognitoFeatureFlag';

/** These existing entry screens do not expose commissioning resources. */
export const isPublicCommissioningEntry = (name: RouteRecordName | null | undefined): boolean =>
  name === 'ComPasswordReset' ||
  (isNativeCognitoEnabled && (name === 'ComLogin' || name === 'ComAccountActivated'));

/**
 * Casts the :projectId in the url to a number. Assumes the route regex has checked for a valid number.
 *
 * @param route - The route object containing the projectId parameter.
 * @returns The projectId as a number.
 */
export const castProjectId = (route: RouteLocationNormalized): { projectId: number } => {
  return { projectId: Number(route.params.projectId) };
};
